// A tiny registry so navigations that leave the editor (e.g. to /upgrade) can
// first ask the editor to persist its draft and stamp the draftId into the URL.
// Without this, clicking an upgrade CTA before autosave fires loses the draft
// and the browser Back button returns to a blank editor.
//
// CreatePost registers a flush on mount and clears it on unmount, so this is a
// no-op on every other page.

type FlushFn = () => Promise<void>;

let currentFlush: FlushFn | null = null;

export function setEditorFlush(fn: FlushFn | null): void {
  currentFlush = fn;
}

export async function flushEditor(): Promise<void> {
  if (!currentFlush) return;
  try {
    await currentFlush();
  } catch (err) {
    console.error("Editor flush failed:", err);
  }
}
